<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Apparato Muscolare" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Masse Muscolari:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoMuscolare.masseMuscolari }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoMuscolare.masseMuscolari" :readonly="isReadOnly" max-rows="9" rows="6"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataApparatoMuscolare.id" @click="onSalvaApparatoMuscolare"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataApparatoMuscolare: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    masseMuscolari: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataApparatoMuscolare: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaApparatoMuscolare: "/rsaschedarelazionesanitariaapparatomuscolare",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaApparatoMuscolare() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaApparatoMuscolare + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaApparatoMuscolareSuccess, me.resultResponseSchedaRelazioneSanitariaApparatoMuscolareError);
        },

        resultResponseSchedaRelazioneSanitariaApparatoMuscolareSuccess(response) {
            let me = this;
            me.jsonDataApparatoMuscolare = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaApparatoMuscolareError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataApparatoMuscolare = {
                id: null,
                idAccettazione: this.idAccettazione,
                masseMuscolari: "",
            };
        },

        onSalvaApparatoMuscolare() {
            let me = this;
            me.jsonDataApparatoMuscolare.idAccettazione = me.idAccettazione;
            if (!me.jsonDataApparatoMuscolare.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaApparatoMuscolare, me.jsonDataApparatoMuscolare, me.saveSchedaRelazioneSanitariaApparatoMuscolareSuccessResponse, me.saveSchedaRelazioneSanitariaApparatoMuscolareErrorResponse);
        },
        saveSchedaRelazioneSanitariaApparatoMuscolareSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Apparato muscolare salvato con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaApparatoMuscolareErrorResponse() {
            console.error("Errore nel salvataggio dell'apparato muscolare:");
        },
    },
};
</script>
